<template>
    <transition name="info-box-fade">
        <div
            :class="{small, active}"
            class="info-box"
            @click="openModal"
        >
            <Modal v-model="modalOpen" :background="background">
                <div class="info-box-modal-content" :class="modalClass">
                    <div class="close-button" data-close />
                    <h4>
                        <slot name="header" />
                    </h4>
                    <slot />
                </div>
            </Modal>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'InfoBox',
    props: {
        active: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        background: {
            type: String,
            default: 'blue'
        },
        modalClass: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        modalOpen: false
    }),
    watch:
    {
        modalOpen(val)
        {
            if (!val)
            {
                this.$emit('closed');
            }
        }
    },
    methods: {
        openModal()
        {
            this.modalOpen = true;
        }
    }
};
</script>

<style lang="scss" src="./InfoBox.scss" />

